import React from "react";
import { faBriefcase, faPersonWalkingArrowRight } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Experience"
				body={
					<div className="works-body">
						<div className="work">
							<div className="work-title">Volunteer - Study Club (PLUGIN)</div>
							<div className="work-subtitle">
								Mentor - Web Developer
							</div>
							<div className="work-duration">2019 - Present</div>
						</div>

						<div className="work">
							<div className="work-title">Committee - Campust Events (INVOFEST)</div>
							<div className="work-subtitle">
								IT Support
							</div>
							<div className="work-duration">2019 - Present</div>
						</div>
						<div>
							<Link to={'/experience'}  className="display-more">
								<div className="work-title">More</div>
								<FontAwesomeIcon icon={faPersonWalkingArrowRight} />
							</Link>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
